import { usersUtil, TYPES } from 'services/utils/users-util';

export class Enterprise {
  static showActions(user) {
    return (
      usersUtil.isAdmin(user) ||
      usersUtil.hasType(user, TYPES.GENERAL_CONTRACTOR)
    );
  }

  static showMyProjects(user) {
    return (
      usersUtil.hasType(user, TYPES.GENERAL_CONTRACTOR) &&
      !usersUtil.hasRole(user, 'field_ops_manager') &&
      !usersUtil.hasRole(user, 'project_executive')
    );
  }

  static spackle(contribType) {
    return contribType === 'Spackle';
  }

  static generalContractor(contribType) {
    return contribType === 'GeneralContractor';
  }

  static primary(contribType) {
    return contribType === 'Primary';
  }

  static subcontractor(contribType) {
    return contribType === 'Subcontractor';
  }

  static spackleOrGc(contribType) {
    return contribType === 'Spackle' || contribType === 'GeneralContractor';
  }
}



// WEBPACK FOOTER //
// ./src/domain/enterprise.js